// Bespoke client for the admin-users API (/api/admin-users) — Auth0-backed in prod, local DB in dev.
// Hand-written (lives beside its consumer; `src/API/` is regenerated). Uses the shared axios
// instance so the admin token is attached by the Auth0AxiosBridge interceptor.
import axios from "axios";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface AdminUser {
	id: string;
	email: string;
	name?: string | null;
	picture?: string | null;
	blocked: boolean;
	roles: string[];
	lastLogin?: string | null;
	createdAt?: string | null;
	source: string;
}

export interface AssignableRole {
	key: string;
	name: string;
	description?: string | null;
	isSystem: boolean;
}

export interface CreateUserBody {
	email: string;
	name?: string;
	password?: string;
	roles: string[];
}

export interface UpdateUserBody {
	name?: string;
	blocked?: boolean;
	roles?: string[];
}

export const usersClient = {
	async list(search?: string): Promise<{ source: string; users: AdminUser[] }> {
		const r = await axios.get(`${apiBase}/api/admin-users`, {
			params: search ? { search } : undefined,
			withCredentials: true
		});
		return r.data ?? { source: "local", users: [] };
	},
	async assignableRoles(): Promise<AssignableRole[]> {
		const r = await axios.get<AssignableRole[]>(`${apiBase}/api/admin-users/assignable-roles`, { withCredentials: true });
		return r.data ?? [];
	},
	async create(body: CreateUserBody): Promise<AdminUser> {
		const r = await axios.post<AdminUser>(`${apiBase}/api/admin-users`, body, { withCredentials: true });
		return r.data;
	},
	async update(id: string, body: UpdateUserBody): Promise<AdminUser> {
		const r = await axios.put<AdminUser>(`${apiBase}/api/admin-users/${encodeURIComponent(id)}`, body, { withCredentials: true });
		return r.data;
	},
	async remove(id: string): Promise<void> {
		await axios.delete(`${apiBase}/api/admin-users/${encodeURIComponent(id)}`, { withCredentials: true });
	}
};
